export default function getLabel(language, key, translations = {}, default_translation) {
    if (language && key in translations) {
        if (translations[key][language.toLowerCase()]) {
            return translations[key][language.toLowerCase()];
        }
    }
    return default_translation;
}
